
/**
 * 全ページ共通の処理
 */

// ユーザーエージェント確認
import check_ua from '../caracol_es2015.1.0/util/check_user_agent';
// プログレス
import progress from '../module/progress';
// ページスクロール
import CaracolPageScroll from '../caracol_es2015.1.0/effect/pagescroll';
// スクロール感知でクラス付与
import CaracolScrollAmount from '../caracol_es2015.1.0/effect/scroll_amount';
// シェアボタン
import share_button from '../caracol_es2015.1.0/social/share_button';
// ポップアップ設定
import popup from '../module/popup';
// メニュー動作
import menu from '../module/menu';
// 花びら
import flower from '../module/flower/flower';

export default function () {

    // メディアクエリーを判定
    const media_type = $('.p-check-media').css('display') === 'block' ? 'large' : 'mobile';
    $('body').attr('data-media-type', media_type);

    // プログレス
    progress();

    // ページスクロール
    let pagescroll;
    if (media_type === 'large') {
        pagescroll = new CaracolPageScroll('a.js-pagescroll', { time: 800, plus: -60 });
    } else {
        pagescroll = new CaracolPageScroll('a.js-pagescroll', { time: 800, plus: -40 });
    }

    // ヘッダと、ページトップに戻るボタンのアクション
    const scroll_amount = new CaracolScrollAmount('.js-scroll-amount');

    // ソーシャルボタン
    share_button('.js-share-button');

    // 画像の遅延読み込み
    $('img.js-lazy').lazyload({ effect: 'fadeIn' });

    // ポップアップ設定
    popup();

    // メニュー動作
    menu();

    // 花びら
    flower();

}



// WEBPACK FOOTER //
// ./js/page/common.js